import * as React from 'react';
export default function SvgShieldCross() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.693 4.066a.75.75 0 01.614 0l7.25 3.25a.75.75 0 01.441.634L19.25 8l.748-.05v.004l.001.008.002.029a9.307 9.307 0 01.015.48c.006.322.004.779-.025 1.326-.056 1.089-.218 2.556-.645 4.036-.426 1.475-1.131 3.013-2.308 4.19C15.842 19.219 14.198 20 12 20c-2.198 0-3.842-.781-5.038-1.977-1.177-1.177-1.882-2.715-2.308-4.19-.427-1.48-.589-2.947-.645-4.036a19.769 19.769 0 01-.015-1.703L4 7.991l.002-.029v-.01s0-.002.749.048l-.748-.05a.75.75 0 01.441-.634l7.25-3.25zm-6.21 4.427v.002c-.004.294-.003.716.024 1.224.053 1.02.204 2.365.589 3.698.386 1.338.994 2.612 1.927 3.545.913.913 2.175 1.538 3.977 1.538s3.064-.625 3.977-1.538c.933-.933 1.541-2.207 1.927-3.545.386-1.333.536-2.678.59-3.698.026-.508.027-.93.023-1.224v-.002L12 5.572 5.483 8.493z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.78 9.22a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 01-1.06-1.06l4.5-4.5a.75.75 0 011.06 0z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22 9.22a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06l-4.5-4.5a.75.75 0 010-1.06z",
    fill: "currentColor"
  }));
}